import { cva } from 'cva'

export const chipV3Style = cva({
  base: [
    ['py-5 border rounded-xl text-sm flex-1 text-center'],
    ['data-[selected=selected]:border-[#6ABE36]', 'data-[selected=selected]:bg-[#F2FCEC]'],
    ['data-[selected=un-selected]:border-[#E8E8E8]', 'data-[selected=un-selected]:bg-white'],
  ],

  variants: {
    direction: {
      vertical: ['px-4'],
      horizontal: ['px-2'],
    },
  },

  defaultVariants: {
    direction: 'horizontal',
  },
})
